var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledFavorites(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4255 3C16.0063 3 17.8337 5.48483 17.8337 7.90039C17.8336 9.08878 17.3717 10.2526 16.6365 11.3486C15.9016 12.4439 14.9111 13.4448 13.9001 14.2969C12.8908 15.1475 11.8744 15.8391 11.1013 16.3174C10.7153 16.5562 10.3916 16.7407 10.1628 16.8643C10.101 16.8976 10.0459 16.9245 9.99976 16.9482C9.95363 16.9245 9.89842 16.8976 9.83667 16.8643C9.60781 16.7407 9.2843 16.5563 8.89819 16.3174C8.12517 15.8391 7.10958 15.1475 6.10034 14.2969C5.08921 13.4447 4.09791 12.4441 3.36304 11.3486C2.62783 10.2526 2.16685 9.08878 2.16675 7.90039C2.16675 5.48489 3.99335 3.00012 6.57397 3C8.06867 3 9.04315 3.75074 9.61987 4.42773L9.99976 4.87402L10.3806 4.42773C10.9573 3.75081 11.9311 3.00015 13.4255 3Z",
    fill: "#FF3C3F",
    stroke: "#FF3C3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledFavorites);
export default __webpack_public_path__ + "static/media/filledFavorites.64e9948939b2c866425b3bf4eb8a3724.svg";
export { ForwardRef as ReactComponent };